export const FEATURED_EVENTS_LOADING_KEY = 'isFeaturedEventsLoading';
export const SET_FEATURED_EVENTS_LOADING = 'SET_FEATURED_EVENTS_LOADING';
export const setFeaturedEventsLoading = (isLoading: boolean) => ({
    type: SET_FEATURED_EVENTS_LOADING,
    payload: {
        [FEATURED_EVENTS_LOADING_KEY]: isLoading,
    },
});

export const FEATURED_EVENTS_CALL_SUCCESS = 'FEATURED_EVENTS_CALL_SUCCESS';
export const setFeaturedEventsCallAsSuccess = () => ({
    type: FEATURED_EVENTS_CALL_SUCCESS,
    payload: {
        [FEATURED_EVENTS_LOADING_KEY]: false,
    },
});

export const FEATURED_EVENTS_CALL_ONGOING = 'FEATURED_EVENTS_CALL_ONGOING';
export const setFeaturedEventsCallAsOngoing = () => ({
    type: FEATURED_EVENTS_CALL_ONGOING,
    payload: {
        [FEATURED_EVENTS_LOADING_KEY]: true,
    },
});

export const FEATURED_EVENTS_CALL_FAILED = 'FEATURED_EVENTS_CALL_FAILED';
export const setFeaturedEventsCallAsFailed = () => ({
    type: FEATURED_EVENTS_CALL_FAILED,
    payload: {
        [FEATURED_EVENTS_LOADING_KEY]: false,
    },
});

export const FEATURED_EVENTS_CALLS_WITH_LOADING = [
    SET_FEATURED_EVENTS_LOADING,
    FEATURED_EVENTS_CALL_SUCCESS,
    FEATURED_EVENTS_CALL_ONGOING,
    FEATURED_EVENTS_CALL_FAILED,
];
